import { Component } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-start-experiment',
  imports: [CommonModule],
  templateUrl: './start-experiment.component.html',
  styleUrl: './start-experiment.component.scss',
})
export class StartExperimentComponent {
  constructor(private router: Router) {}

  goToExperiment(participantIdentifier: string, trialSequenceNumber: string) {
    if (participantIdentifier?.length == 0) {
      alert('參加者識別碼不可留空');
      return;
    }
    if (!trialSequenceNumber || trialSequenceNumber === '') {
      alert('請選擇測試序列');
      return;
    }
    
    this.router.navigate(['/experiment', participantIdentifier, trialSequenceNumber]);
    this.enterFullScreen();
  }

  // Enter full screen
  private enterFullScreen() {
    const doc = document.documentElement;
    if (doc.requestFullscreen) {
      doc.requestFullscreen();
    }
  }
}
